import axios from 'axios';
import isNil from 'lodash/isNil';
import isPlainObject from 'lodash/isPlainObject';

const SENSITIVE_REQUEST_BODY_KEYS = new Set([
  'password',
  'secret',
  'sharedSecret',
  'token',
  'refreshToken'
]);

export function redactRequestBodyForLogging(data: unknown): unknown {
  if (isNil(data) || data === '') {
    return data;
  }

  let parsed: Record<string, unknown>;
  const asString = typeof data === 'string';

  if (asString) {
    try {
      const parsedData: unknown = JSON.parse(data);
      if (!isPlainObject(parsedData)) {
        return data;
      }
      parsed = parsedData as Record<string, unknown>;
    } catch {
      return data;
    }
  } else if (isPlainObject(data)) {
    parsed = { ...data as Record<string, unknown> };
  } else {
    return data;
  }

  for (const key of Object.keys(parsed)) {
    if (SENSITIVE_REQUEST_BODY_KEYS.has(key)) {
      parsed[key] = '********';
    }
  }

  return asString ? JSON.stringify(parsed) : parsed;
}

export function redactAxiosErrorForLogging(error: unknown): unknown {
  if (!axios.isAxiosError(error)) {
    return error;
  }

  return {
    ...error.toJSON(),
    config: error.config && {
      ...error.config,
      data: redactRequestBodyForLogging(error.config.data)
    }
  };
}
